import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "popup",
  class: "group fixed left-1/2 top-1/2 m-0 grid place-items-center pointer-events-none opacity-0 -translate-x-1/2 -translate-y-1/2 size-full bg-transparent transition-opacity duration-300 open:pointer-events-auto open:opacity-100 backdrop:bg-base-500/60"
}
const _hoisted_2 = { class: "flex flex-col items-center gap-7 p-5 w-full max-w-[600px] bg-white -translate-y-16 group-open:translate-y-0 transition-transform duration-300 rounded-lg" }
const _hoisted_3 = { class: "flex justify-between items-center w-full" }
const _hoisted_4 = { class: "text-md" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "flex justify-end flex-col md:flex-row items-center gap-3 w-full" }

import { useTemplateRef } from 'vue';
import Button from '../base/Button.vue';
import IconClose from '../icons/IconClose.vue';

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'PopupTextarea',
  props: /*@__PURE__*/_mergeModels({
    cancelButtonText: {},
    confirmButtonText: {},
    heading: {},
    placeholder: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["popupConfirm", "popupCancel"], ["update:modelValue"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {



// Emits
const emit = __emit;

// Store popup in ref
const popupRef = useTemplateRef('popup');

// Open popup
const openPopup = () => {
    popupRef.value.showModal();
};

// Close popup
const closePopup = () => {
    popupRef.value.close();

    // Reset the value
    value.value = '';

	emit('popupCancel');
};

// Expose both functions to the parent
__expose({ openPopup, closePopup });

// Define returned value
const value = _useModel<string>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dialog", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.heading), 1),
        _createVNode(IconClose, {
          class: "cursor-pointer",
          onClick: closePopup,
          onKeypress: _withKeys(closePopup, ["enter","space"]),
          tabindex: "0"
        })
      ]),
      _withDirectives(_createElementVNode("textarea", {
        class: "w-full px-2 py-1 text-base leading-base placeholder:text-base-200 text-base-500 rounded border border-neutral-500 resize-none min-h-[134px]",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        placeholder: _ctx.placeholder
      }, null, 8, _hoisted_5), [
        [_vModelText, value.value]
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(Button, {
          class: "max-md:w-full",
          text: _ctx.cancelButtonText,
          type: "secondary",
          onClick: _withModifiers(closePopup, ["prevent"])
        }, null, 8, ["text"]),
        _createVNode(Button, {
          class: "max-md:w-full",
          text: _ctx.confirmButtonText,
          type: "primary",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('popupConfirm')), ["prevent"]))
        }, null, 8, ["text"])
      ])
    ])
  ], 512))
}
}

})